<template>
  <section class="social-section py-5 position-relative overflow-hidden" id="redes">
    <!-- Bowl Decorativo Flotante Disperso (Salmón Fit) -->
    <div class="floating-bowl-decor bowl-redes d-none d-lg-block">
      <img
        :src="require('@/assets/img/NEW Delivery_1.png')"
        alt="Salmón Fit"
        class="img-fluid floating-bowl-img"
      />
    </div>

    <!-- Capa de difuminado y viñeta para la imagen de fondo fondo.webp -->
    <div class="social-bg-overlay"></div>

    <div class="container position-relative z-2">
      <!-- Encabezado estilo Fitgym -->
      <div class="row text-center mb-4 mb-md-5">
        <div class="col-12">
          <h2 class="social-headline text-white m-0">
            ¿YA NOS SIGUES?
          </h2>

          <p class="social-subtext text-white-50 mt-2 mx-auto">
            DESCUBRE TODAS LAS NOVEDADES DE THE FIT BAR EN REDES SOCIALES
          </p>
        </div>
      </div>

      <!-- Cuadrícula de Redes Sociales (Estilo Fitgym) -->
      <div class="row g-3 g-md-4 align-items-stretch">
        <!-- Columna Izquierda: Tarjeta Vertical Alta (TikTok) -->
        <div class="col-12 col-lg-6">
          <a
            href="https://www.tiktok.com/@thefitbarcancun"
            target="_blank"
            rel="noopener noreferrer"
            class="social-card tall-card position-relative d-block overflow-hidden"
          >
            <img
              :src="require('@/assets/img/fitbar_social_tiktok.jpg')"
              alt="The Fit Bar en TikTok - Bowls & Smoothies"
              class="social-card-img"
              loading="lazy"
              width="600"
              height="800"
            />
            <div class="card-overlay"></div>

            <div class="social-handle d-flex align-items-center gap-2">
              <span class="handle-icon tiktok-icon">
                <i class="bi bi-tiktok"></i>
              </span>
              <span class="handle-text">@thefitbarcancun</span>
            </div>
          </a>
        </div>

        <!-- Columna Derecha: Dos Tarjetas Horizontales (Instagram & Facebook) -->
        <div class="col-12 col-lg-6 d-flex flex-column gap-3 gap-md-4">
          <!-- Tarjeta Superior: Instagram -->
          <a
            href="https://www.instagram.com/thefitbarcancun/"
            target="_blank"
            rel="noopener noreferrer"
            class="social-card wide-card position-relative d-block overflow-hidden flex-grow-1"
          >
            <img
              :src="require('@/assets/img/fitbar_social_instagram.jpg')"
              alt="The Fit Bar en Instagram - Gourmet Salmón & Bowls"
              class="social-card-img"
              loading="lazy"
              width="600"
              height="340"
            />
            <div class="card-overlay"></div>

            <div class="social-handle d-flex align-items-center gap-2">
              <span class="handle-icon insta-icon">
                <i class="bi bi-instagram"></i>
              </span>
              <span class="handle-text">@thefitbarcancun</span>
            </div>
          </a>

          <!-- Tarjeta Inferior: Facebook -->
          <a
            href="https://www.facebook.com/fitbarcancun"
            target="_blank"
            rel="noopener noreferrer"
            class="social-card wide-card position-relative d-block overflow-hidden flex-grow-1"
          >
            <img
              :src="require('@/assets/img/fitbar_social_facebook.jpg')"
              alt="The Fit Bar en Facebook - Desayunos Fit & Jugos"
              class="social-card-img"
              loading="lazy"
              width="600"
              height="340"
            />
            <div class="card-overlay"></div>

            <div class="social-handle d-flex align-items-center gap-2">
              <span class="handle-icon fb-icon">
                <i class="bi bi-facebook"></i>
              </span>
              <span class="handle-text">@fitbarcancun</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RedesSociales",
};
</script>

<style scoped>
.social-section {
  position: relative;
  background-color: #0a0a0a;
  background-image: url('@/assets/img/fondo.webp');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  margin-bottom: 0 !important;
}

/* Capa oscura con viñeta y difuminado suave arriba y abajo */
.social-bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(180deg, #0a0a0a 0%, rgba(10, 10, 10, 0.65) 15%, rgba(10, 10, 10, 0.65) 85%, #0a0a0a 100%),
    radial-gradient(circle at center, rgba(10, 10, 10, 0.55) 0%, rgba(10, 10, 10, 0.92) 100%);
  pointer-events: none;
  z-index: 1;
}

.z-2 {
  position: relative;
  z-index: 2 !important;
}

/* Tipografía de Encabezado estilo Fitgym */
.social-headline {
  font-family: 'Montserrat', sans-serif;
  font-weight: 900;
  font-size: clamp(2rem, 4.5vw, 3.2rem);
  letter-spacing: -0.01em;
  text-transform: uppercase;
}

.social-subtext {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(0.78rem, 1.8vw, 0.95rem);
  letter-spacing: 0.14em;
  font-weight: 600;
  max-width: 680px;
}

/* Tarjetas Sociales */
.social-card {
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.6);
  cursor: pointer;
  text-decoration: none;
  background-color: #121212;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.tall-card {
  height: 100%;
  min-height: 480px;
}

.wide-card {
  min-height: 228px;
}

/* Imagen con zoom al hover */
.social-card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.social-card:hover .social-card-img {
  transform: scale(1.06);
}

/* Overlay para contraste de texto */
.card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(10, 10, 10, 0.1) 0%,
    rgba(10, 10, 10, 0.25) 50%,
    rgba(10, 10, 10, 0.88) 100%
  );
  transition: opacity 0.3s ease;
  z-index: 1;
}

.social-card:hover {
  border-color: rgba(253, 111, 60, 0.55);
  box-shadow: 0 14px 40px rgba(253, 111, 60, 0.25);
  transform: translateY(-4px);
}

/* Identificador / Handle en esquina inferior izquierda */
.social-handle {
  position: absolute;
  bottom: 22px;
  left: 24px;
  z-index: 2;
  background: rgba(10, 10, 10, 0.65);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 8px 16px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: all 0.3s ease;
}

.social-card:hover .social-handle {
  background: rgba(253, 111, 60, 0.9);
  border-color: #fd6f3c;
  box-shadow: 0 4px 18px rgba(253, 111, 60, 0.6);
}

.handle-icon {
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fd6f3c;
  transition: color 0.3s ease;
}

.social-card:hover .handle-icon {
  color: #ffffff;
}

.handle-text {
  font-family: 'Montserrat', sans-serif;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: 0.02em;
}

/* Responsivo para móviles */
@media (max-width: 991px) {
  .social-section {
    background-attachment: scroll;
    background-position: center top;
  }
  .tall-card {
    min-height: 380px;
  }
  .wide-card {
    min-height: 200px;
  }
}

@media (max-width: 576px) {
  .tall-card {
    min-height: 340px;
  }
  .wide-card {
    min-height: 190px;
  }
  .social-handle {
    bottom: 16px;
    left: 16px;
    padding: 6px 12px;
  }
  .handle-icon {
    font-size: 1.1rem;
  }
  .handle-text {
    font-size: 0.85rem;
  }
}

/* Bowl Decorativo Flotante Disperso (Salmón Fit) */
.floating-bowl-decor {
  position: absolute;
  z-index: 5;
  pointer-events: none;
  filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.7));
}

.bowl-redes {
  top: 35px;
  right: clamp(20px, 6vw, 110px);
  animation: floatBowlRedes 6.5s ease-in-out infinite alternate;
}

.floating-bowl-img {
  width: 215px;
  height: 215px;
  object-fit: contain;
  transform: rotate(8deg);
  transition: transform 0.3s ease;
}

.bowl-label-mini {
  background: rgba(15, 18, 20, 0.88);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(253, 111, 60, 0.4);
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 12px;
  border-radius: 20px;
  text-align: center;
  margin-top: -8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  white-space: nowrap;
}

@keyframes floatBowlRedes {
  0% { transform: translateY(0) rotate(0deg); }
  100% { transform: translateY(15px) rotate(4deg); }
}
</style>
